import React, { memo } from "react";
// import ConfigCtas from "../cta/ConfigCtas";
import clsx from "clsx";
import Upholstery from "./Upholstery";
import styles from "./SpinContainer.module.scss";
import SpinNavigation, { SPIN_CONTAINER_ID } from "./SpinNavigation";
import { useCarConfigSelector } from "../../../../redux/store";
import { CarConfigConfigureSection } from "../../../../utils/types/SectionTypes";
import Exterior360Wrapper from "./exterior-360/Exterior360Wrapper";
import a11y from "../../../../../shared-components/css-modules/toyota/utils/Accessibility.module.scss";
import Button from "../../../../../shared-components/css-modules/toyota/atoms/Button";
import { CarConfigLabel, useCarConfigLabel } from "../../../../utils/labelUtils";

const SpinContainer: React.FC = () => {
    const activeSection = useCarConfigSelector((state) => state.carConfigNavigation.activeSection);

    const spinnerIsInactive = useCarConfigSelector(
        (state) =>
            !state.car.initialized ||
            state.carConfigNavigation.activeSection === CarConfigConfigureSection.Summary ||
            state.carConfigNavigation.activeSection === CarConfigConfigureSection.Charging,
    );

    const spinLabel = useCarConfigLabel("ariaSpinNavigation");

    return (
        <section className={styles.spin} id={SPIN_CONTAINER_ID} tabIndex={0} aria-label={spinLabel}>
            <div className={`${styles["spin-container"]} ${spinnerIsInactive ? styles.faded : styles.active}`}>
                {!spinnerIsInactive && (
                    <div className={styles["spin-container-visual"]}>
                        {/*note: Spin should be transparent png transparent*/}
                        <div className={styles["spin-container-items"]}>
                            <Exterior360Wrapper />

                            <div className={styles.intro}>
                                <CarConfigLabel label="carConfigIntroText" useHTML />
                            </div>
                        </div>
                        <Upholstery />
                        <div className={styles["spin-navigation-wrapper"]}>
                            <SpinNavigation showFullscreen />
                        </div>
                    </div>
                )}
                {activeSection && (
                    <Button
                        variant="btn-default"
                        href={`#${activeSection}`}
                        className={clsx(a11y["skip-to-content"], styles.skip)}
                    >
                        <CarConfigLabel label="ariaReturnToConfiguration" />
                    </Button>
                )}
            </div>
            {/*TODO: Config CTAS to be implemented in a later stadium*/}
            {/*<div className={styles["config-ctas-spin"]}>*/}
            {/*    <ConfigCtas />*/}
            {/*</div>*/}
        </section>
    );
};

export default memo(SpinContainer);
